import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import routes from 'routes';

import Boosters from 'components/booster/Boosters';

import { useAppSelector } from 'hooks/app';
import useBoosters from 'hooks/useBoosters';

type LeagueFilter = 'all' | 'nba' | 'nfl' | 'mlb' | 'wnba';

const BoostersPage = () => {
  const contest = useAppSelector((state) => state.contest.contest);
  const participation = useAppSelector((state) => state.contest.participation);
  const { boosters, isLoading, isFetching, setBooster, fetchBoosters } = useBoosters({ contest });

  useEffect(() => {
    if (contest) {
      fetchBoosters({ league: contest.league });
    }
  }, [contest, fetchBoosters]);

  const handleLeagueChange = (league: LeagueFilter) => {
    fetchBoosters({ league });
  };

  if (contest?.status !== 'active' || !participation || !contest) {
    return <Navigate to={routes.home} replace />;
  }

  if (participation?.status === 'cards_pending') {
    return <Navigate to={routes.builder} replace />;
  }

  if (participation.booster || participation.status === 'completed') {
    return <Navigate to={routes.squad} replace />;
  }

  return (
    <Boosters
      league={contest.league}
      boosters={boosters}
      onSelect={setBooster}
      isLoading={isLoading || isFetching}
      onLeagueChange={handleLeagueChange}
      title="Pick Boost"
      subTitle="Score from extra stat"
      disableLeagueChange={true}
    />
  );
};

export default BoostersPage;
